import {
  useContext,
  useEffect,
  useState,
} from "react";

import Context from "../../context/AppContext";

import {
  NavLink as Link,
  useNavigate,
} from "react-router-dom";

import { logoutApi } from "../../services/api";

import {
  getAvailableTravelPoints,
  toTitleCase,
} from "../../utils/helpers";

const Sidebar = () => {
  const [menuOpen, setMenuOpen] =
    useState(() => window.innerWidth > 767);

  const [travelPoints, setTravelPoints] =
    useState(0);

  const [pointsLoading, setPointsLoading] =
    useState(false);
  
  const [walletDropdownOpen, setWalletDropdownOpen] =
  useState(false);

  const {
    setUser,
    user,
    account,
    onConnect,
  } = useContext(Context);

  const navigate = useNavigate();

  // -----------------------------------------
  // MENU
  // -----------------------------------------
  const handleToggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };
async function handleLogout() {
  try {
    setWalletDropdownOpen(false);

    await logoutApi();

    setUser(null);

    navigate("/login", {
      replace: true,
    });
  } catch (error) {

    setUser(null);

    navigate("/login", {
      replace: true,
    });
  }
}

  const mobileMenuToggle = () => {
    if (window.innerWidth <= 767) {
      setMenuOpen((prev) => !prev);
    }
  };

  // -----------------------------------------
  // LOGOUT
  // -----------------------------------------

  async function handleLogout() {
    await logoutApi();

    setUser(null);

    navigate("/login", {
      replace: true,
    });
  }

  // -----------------------------------------
  // MENU CLASS
  // -----------------------------------------

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add(
        "menu_open"
      );
    } else {
      document.body.classList.remove(
        "menu_open"
      );
    }

    return () => {
      document.body.classList.remove(
        "menu_open"
      );
    };
  }, [menuOpen]);

  // -----------------------------------------
  // THEME
  // -----------------------------------------

  useEffect(() => {
    const savedTheme =
      localStorage.getItem(
        "travelTheme"
      );

    const isDark =
      savedTheme !== "light";

    document.body.classList.toggle(
      "light-theme",
      !isDark
    );

    document.body.classList.toggle(
      "dark-theme",
      isDark
    );
  }, []);

  // -----------------------------------------
  // FETCH TRAVEL POINTS
  // -----------------------------------------

  useEffect(() => {
    let active = true;

    const loadTravelPoints =
      async () => {
        if (!user.wallet_address) {
          if (active) {
            setTravelPoints(0);
            setPointsLoading(false);
          }

          return;
        }

        try {
          setPointsLoading(true);

          const points =
            await getAvailableTravelPoints(
              user.wallet_address
            );

          if (!active) return;

          setTravelPoints(
            points ?? 0
          );
        } catch (error) {
          console.error(
            "Unable to fetch travel points:",
            error
          );

          if (!active) return;

          setTravelPoints(0);
        } finally {
          if (active) {
            setPointsLoading(false);
          }
        }
      };

    loadTravelPoints();

    return () => {
      active = false;
    };
  }, [account]);

  // -----------------------------------------
  // ADDRESS FORMAT
  // -----------------------------------------

  const shortenAddress = (address) => {
    if (!address) return "";

    if (address.length <= 12) {
      return address;
    }

    return `${address.slice(
      0,
      6
    )}..${address.slice(-4)}`;
  };

  return (
    <>
      <div
        className={`sideBar ${
          menuOpen ? "Yes" : ""
        }`}
      >
        <button
          type="button"
          className="text-white menubtn d-block d-md-none"
          onClick={handleToggleMenu}
        >
          <i className="fa-solid fa-close"></i>
        </button>

        <div className="logo">
          <Link to="/">
            <img
              src="/images/logo_big.png"
              className="img-fluid"
              alt="Trust Bitcoin"
            />
          </Link>
        </div>

        <div className="topNavi navigationSidebar">
          <ul>
            <li>
              <Link
                onClick={
                  mobileMenuToggle
                }
                to="/dashboard"
              >
                <i className="fa-solid fa-house"></i>{" "}
                Dashboard
              </Link>
            </li>

            <li>
              <Link
                onClick={
                  mobileMenuToggle
                }
                to="/profile"
              >
                <i className="fa-solid fa-user"></i>{" "}
                Profile
              </Link>
            </li>

            <li>
              <Link
                onClick={
                  mobileMenuToggle
                }
                to="/my-travelers"
              >
                <i className="fa-solid fa-users"></i>{" "}
                Saved Passengers
              </Link>
            </li>

            <li>
              <Link
                onClick={
                  mobileMenuToggle
                }
                to="/my-tours"
              >
                <i className="fa-solid fa-plane"></i>{" "}
                My Tours
              </Link>
            </li>

            <li>
              <Link
                onClick={
                  mobileMenuToggle
                }
                to="/upcoming-tours"
              >
                <i className="fa-solid fa-list-check"></i>{" "}
                Upcoming Tours
              </Link>
            </li>

            <li>
              <Link
                onClick={
                  mobileMenuToggle
                }
                to="/completed-tours"
              >
                <i className="fa-solid fa-circle-check"></i>{" "}
                Completed Tours
              </Link>
            </li>

            <li>
              <Link
                onClick={
                  mobileMenuToggle
                }
                to="https://trustbitcoin.io/"
                target="_blank"
              >
                <i className="fa-solid fa-earth-americas"></i>{" "}
                Main Website
              </Link>
            </li>

            <li>
              <button
                type="button"
                onClick={
                  handleLogout
                }
              >
                <i className="fa-solid fa-arrow-right-from-bracket"></i>{" "}
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="topbar sidebarPadding">
        <div className="topbarIN">
          <div className="d-flex align-items-center justify-content-between w-100">

            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

              <button
                type="button"
                className="text-white menubtn"
                onClick={
                  handleToggleMenu
                }
              >
                <i className="fa-solid fa-bars"></i>
              </button>

              <span className="menuUerName d-none d-md-block">
                {user?.name
                  ? toTitleCase(
                      user.name.toLowerCase()
                    )
                  : ""}
              </span>

            </div>

            <div className="r d-flex gap-3 align-items-center">

              {/* TRAVEL POINTS */}
              <div className="searchBarHere">
                <Link
                  to="#"
                  className="loginBTN"
                  onClick={(e) => {
                    e.preventDefault();

                    if (!account) {
                      onConnect();
                    }
                  }}
                >
                  <span>
                    <i
                      style={{
                        fontSize:
                          "14px",
                      }}
                      className="userICON fa-solid fa-gem"
                    ></i>
                  </span>

                  {pointsLoading
                    ? <><i className="fa-solid fa-spinner fa-spin me-2"></i></>
                    : travelPoints}
                </Link>
              </div>
<div
  className="searchBarHere"
  style={{
    position: "relative",
  }}
>
    <>
      <button
        type="button"
        className="loginBTN"
        onClick={() =>
          setWalletDropdownOpen(
            (prev) => !prev
          )
        }
        style={{
          border: "none",
        }}
      >
        <span>
          <i
            style={{
              fontSize: "12px",
            }}
            className="userICON fa-solid fa-wallet"
          ></i>
        </span>

        {shortenAddress(user.wallet_address)}

        <i
          className={`fa-solid ${
            walletDropdownOpen
              ? "fa-chevron-up"
              : "fa-chevron-down"
          } ms-2`}
          style={{
            fontSize: "10px",
            opacity: 0.6,
          }}
        ></i>
      </button>

      {walletDropdownOpen && (
        <div
          className="walletDropdownMenu"
          style={{
            position: "absolute",
            top: "calc(100% + 0px)",
            right: 0,
            minWidth: "172px",
            zIndex: 99999,
          }}
        >
          <button
            type="button"
            className="walletDropdownItem"
            onClick={handleLogout}
          >
            <i className="fa-solid fa-right-from-bracket me-2"></i>

            Logout
          </button>
        </div>
      )}
    </>
 
</div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;